import { mapGetters } from 'vuex';
import contentHeader from '@/components/generics/content-header/content-header.vue';
import loaderMixin from '@/mixins/loader';
import notificationsList from '@/components/notifications-list/notifications-list.vue';
import unreadNotificationMixin from '@/mixins/unreadNotification';

export default {
  mixins: [
    loaderMixin,
    unreadNotificationMixin,
  ],
  components: {
    contentHeader,
    notificationsList,
  },
  metaInfo() {
    return {
      title: 'Notifications',
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
  },
  beforeDestroy() {
    this.clearAllNotifications();
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/dashboard/page-notifications/page-notifications.js